import React from 'react';
import { Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid } from '@material-ui/core'
import SpecificComponent from '../SpecificComponent';





export default class AlertNew extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {

    }


    render() {
        return (
            <div>
                <Dialog
                    className="pm-alert-dialog"
                    disableEscapeKeyDown
                    open={this.props.open}
                    onClose={this.props.dialogClose}
                    style={{ zIndex: 6000 }}
                    fullScreen={this.props.fullScreen ? true : false}
                    fullWidth={true}
                >
                    <DialogActions >
                        {/* <Fab onClick={this.props.dialogClose} className="pm-round-button">
                            <i className='material-icons pm-round-button-text'>close</i>
                        </Fab> */}
                    </DialogActions>


                    <DialogContent>
                        <Grid container>
                            <Grid style={{textAlign:'center'}} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                <i style={{
                                    fontSize: 70,
                                    marginTop: '10%',
                                    color: '#ffc300'
                                }} className='material-icons'>error</i>
                            </Grid>
                            <Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
                                <h3 >{this.props.title}</h3>
                                <p style={{wordBreak:'break-all'}}>{this.props.mesaj}</p>
                                <div>
                                    <Button style={{ padding: '10px 20px 10px 20px', backgroundColor:this.props.deleteP ? 'rgb(243 105 105)': 'rgb(24 166 59)', color: 'white', fontWeight: 500, marginRight: 10 }} onClick={this.props.yesFunction}  >
                                        {this.props.noButtonDisplay === 1 ? this.dictionary.proiecte.ok : this.dictionary.proiecte.yes}
                                    </Button>
                                    <Button style={{ padding: '10px 20px 10px 20px', display: this.props.noButtonDisplay === 1 ? 'none' : 'inline-flex', padding: 10, backgroundColor:this.props.deleteP ? 'rgb(24 166 59)' : 'rgb(243 105 105)', color: 'white', fontWeight: 500 }} onClick={this.props.dialogClose}  >
                                    {this.dictionary.proiecte.no}
                                    </Button>


                                </div>

                            </Grid>
                        </Grid>
                    </DialogContent>

                    {/* <h2 className='pm-dialog-alert-title'>{this.props.title}</h2> */}
                    {/* <DialogActions className="pm-dialog-bottom-buttons">




                    </DialogActions> */}


                </Dialog>
            </div>
        );
    }
}